import { useMutation, useQuery } from "@tanstack/react-query"
import { addEnergyAudit, fetchCurrentEnergyAuditsForAuditor, fetchNewEnergyAuditsForAuditor } from "../api"
import type { AddEnergyAuditForm, EnergyAuditRequestParams } from "../types"

export const useAddEnergyAudit = () => {
  return useMutation({
    mutationFn: (data: AddEnergyAuditForm) => addEnergyAudit(data)
  })
}

export const useFetchNewEnergyAuditsForAuditor = (params: EnergyAuditRequestParams) => {
  return useQuery({
    queryKey: ["energy-audits", "auditor", "new", params],
    queryFn: () => fetchNewEnergyAuditsForAuditor(params)
  })
}

export const useFetchCurrentEnergyAuditsForAuditor = (params: EnergyAuditRequestParams) => {
  return useQuery({
    queryKey: ["energy-audits", "auditor", "current", params],
    queryFn: () => fetchCurrentEnergyAuditsForAuditor(params)
  })
}
